import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import type { DetailsDialogProps } from './types';

export const DIALOG_TYPE = 'TRANSACTION_DETAILS_DIALOG';

export const showTxnDetailsDialog = createAction(
  rootUiActions.createDialog.toString(),
  ({ txn, wrapperId, txnActionCallback, defaultAccountId, ...otherProps }: DetailsDialogProps) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      id: `TRANSACTION_DETAILS_${txn?.id || '0'}`,
      props: ImmutableMap({ txn, wrapperId, txnActionCallback, defaultAccountId, ...otherProps }),
    }),
);
